import { Tooltip, Typography } from '@mui/material';
import { CampaignListRow } from './columns';

type TooltipMetadata = {
  tooltipText: string;
  label: string;
};

const cpgTooltipMetadata = {
  tooltipText: 'This campaign uses LCI CPG methodology',
  label: 'CPG',
} as const satisfies TooltipMetadata;

const lci3TooltipMetadata = {
  tooltipText: 'This campaign uses LCI 3.0 methodology',
  label: 'LCI 3',
} as const satisfies TooltipMetadata;

const rslTooltipMetadata = {
  tooltipText: 'This campaign uses RSL methodology',
  label: 'RSL',
} as const satisfies TooltipMetadata;

type CampaignTypeTooltipProps = {
  campaignType: CampaignListRow['campaignType'];
};

export const CampaignTypeTooltip = (props: CampaignTypeTooltipProps) => {
  const tooltipMetadata: TooltipMetadata = (() => {
    switch (props.campaignType) {
      case 'cpg': {
        return cpgTooltipMetadata;
      }
      case 'rsl':
      case 'rslvisits': {
        return rslTooltipMetadata;
      }
      default: {
        return lci3TooltipMetadata;
      }
    }
  })();
  return (
    <Tooltip title={tooltipMetadata.tooltipText} arrow>
      <Typography>{tooltipMetadata.label}</Typography>
    </Tooltip>
  );
};
